import PropTypes from "prop-types";
import React from "react";

let browser = window;
let popup = null;
let timer = null;

function watcher () {
    if (popup === null) {
        clearInterval(timer);
        timer = null;
    } else if (popup !== null && !popup.closed) {
        popup.focus();
    } else if (popup !== null && popup.closed) {
        clearInterval(timer);
        browser.focus();
        browser.onClose("child was closed");
        timer = null;
        popup = null;
    }
}

export class WindowOpener extends React.Component {

    constructor (props) {
        super(props);

        this.onClickHandler = this.onClickHandler.bind(this);

        browser = window.self;

        browser.onSuccess = (res) => {
            props.bridge(null, res);
        }

        browser.onError = (error) => {
            props.bridge(error);
        }

        browser.onOpen = (message) => {
            props.bridge(null, message);
        }

        browser.onClose = (message) => {
            props.bridge(null, message);
        }
    }

    onClickHandler (evt) {

        const { url, name, width, height } = this.props;
        const opts = `dependent=1, alwaysOnTop=1, alwaysRaised=1, width=${width}, height=${height}, top=200, left=300, scrollbars=no`;

        if (popup && !popup.closed) {
            popup.focus();
            return;
        }

        popup = browser.open(url, name, opts);

        setTimeout(() => {
            popup.opener.onOpen("child was opened");
        }, 0);

        if (timer === null) {
            timer = setInterval(watcher, 2000);
        }

        return;

    }

    render () {
        const { children } = this.props;
        return (
            <button type="button" onClick={this.onClickHandler}>
                {children}
            </button>
        );
    }
}

WindowOpener.propTypes = {
    url: PropTypes.string.isRequired,
    bridge: PropTypes.func.isRequired,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};

WindowOpener.defaultProps = {
    name: "Popup",
    width: 600,
    height: 500
};